module.exports = {
    BOT_URL: process.env.BOT_BASE_URL
}